import { render, staticRenderFns } from "./UserPanelFieldset.vue?vue&type=template&id=619d4942"
import script from "./UserPanelFieldset.vue?vue&type=script&lang=js"
export * from "./UserPanelFieldset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports